<template>
    <div class="row">

        <div class="form-group" :class="{'col-md-2':!isMobile, 'col-md-4':!isMobile}">
            <label for="time_arrived_at_office">Time Arrived At Office</label>
            <input name="time_arrived_at_office" type="time" v-mask="'##:##'" placeholder="00:00"
                   v-model="item.time_arrived_at_office"
                   class="form-control form-report time"/>
        </div>

        <div class="form-group" :class="{'col-md-2':!isMobile, 'col-md-4':!isMobile}">
            <label for="travel_time_to_site">Travel Time To Site</label>
            <input name="travel_time_to_site" @input="formatTime('travel_time_to_site')" placeholder="00:00"
                   v-model="item.travel_time_to_site"
                   class="form-control form-report time"/>
        </div>

        <div class="form-group" :class="{'col-md-2':!isMobile, 'col-md-4':!isMobile}">
            <label for="arrival_time">Arrival Time <span class="opacity-zero">Office</span> <span class="opacity-zero">Site</span></label>
            <input name="arrival_time" type="time" v-mask="'##:##'" placeholder="00:00" v-model="item.arrival_time"
                   class="form-control form-report time"/>
        </div>

        <div class="form-group" :class="{'col-md-2':!isMobile, 'col-md-4':!isMobile}">
            <label for="departure_time">Departure Time <span class="opacity-zero">Office</span> <span
                class="opacity-zero">Site</span></label>
            <input name="departure_time" type="time" v-mask="'##:##'" placeholder="00:00" v-model="item.departure_time"
                   class="form-control form-report time"/>
        </div>

        <div class="form-group" :class="{'col-md-2':!isMobile, 'col-md-4':!isMobile}">
            <label for="travel_time_from_site">Travel Time From Site</label>
            <input name="travel_time_from_site" @input="formatTime('travel_time_from_site')" placeholder="00:00"
                   v-model="item.travel_time_from_site"
                   class="form-control form-report time"/>
        </div>

        <div class="form-group d-flex" :class="{'col-md-2':!isMobile, 'col-md-4':!isMobile}">
            <checkbox-component ref="isLunch" @change="(val) => {item.isLunch = val; $forceUpdate()}" name="isLunch"
                                label="Lunch" :value="item.isLunch"></checkbox-component>

            <select v-if="item.isLunch" name="lunch_time" class="form-control" v-model="item.lunch_time"
                    style="margin-top: 20px; min-width: 80px;">
                <option value="">--:--</option>
                <option value="00:30">00:30</option>
                <option value="00:45">00:45</option>
                <option value="01:00">01:00</option>
            </select>
        </div>

        <div class="form-group" :class="{'col-md-2':!isMobile, 'col-md-4':!isMobile}">
            <label for="straight_time">Straight Time</label>
            <input name="straight_time" @input="formatTime('straight_time')" placeholder="00:00"
                   v-model="item.straight_time"
                   class="form-control form-report time"/>
        </div>

        <div class="form-group" :class="{'col-md-2':!isMobile, 'col-md-4':!isMobile}">
            <label for="overtime">Premium Time</label>
            <input name="overtime" @input="formatTime('overtime')" placeholder="00:00" v-model="item.overtime"
                   class="form-control form-report time"/>
        </div>
        <div class="form-group" :class="{'col-md-2':!isMobile, 'col-md-4':!isMobile}">
            <label for="double_time">Double Time</label>
            <input name="double_time" @input="formatTime('double_time')" placeholder="00:00" v-model="item.double_time"
                   class="form-control form-report time"/>
        </div>

    </div>
</template>

<script>
import {monthNames, URL_BASE, years} from '../../../utils/helper';
import _ from "lodash";
import draggable from 'vuedraggable'
import {mask} from 'vue-the-mask'
import WorkTicketStaffModel from "../../../models/WorkTicketStaffModel";
import CheckboxComponent from "../../CheckboxComponent.vue";

export default {
    name: "TimesheetTime",
    directives: {mask},
    components: {
        CheckboxComponent,
        draggable,
    },
    props: {
        timesheet: {
            required: false,
            default: null
        },
    },
    data: function () {
        return {
            item: {
                time_arrived_at_office: null,
                travel_time_to_site: null,
                isLunch: false,
                lunch_time: ''
            },
            isMobile: false,
        }
    },
    mounted() {
        this.isMobile = this.$root.calculateIsMobile()
        if (this.timesheet) {
            this.item = this.timesheet;
            this.$refs.isLunch.checked = parseInt(this.item.isLunch) === 1
        }
    },
    methods: {
        formatTime(field) {
            let timeDigitsOnly = this.item[field].replace(/\D/g, '');
            timeDigitsOnly = timeDigitsOnly.padStart(4, '0');
            const lastFourDigits = timeDigitsOnly.slice(-4);

            let hours = lastFourDigits.slice(0, 2);
            let minutes = lastFourDigits.slice(2);

            if (field !== 'travel_time_from_site') {
                if (parseInt(hours) > 24) {
                    hours = 24;
                }
            }


            this.item[field] = `${hours}:${minutes}`;
        }
    }
}
</script>

<style scoped>
.opacity-zero {
    opacity: 0;
}

.form-report {
    min-width: 120px;
    border-top: none !important;
    border-left: none !important;
    border-right: none !important;
    border-bottom: 1px solid !important;
}
</style>
